export default __webpack_public_path__ + "static/media/portfolio_02.c637da78.png";